
export const ScheduleRoute = '/schedule/';
export const GameRoute = '/game/';
export const PlayerRoute = '/player/';
